import { getBaseMetaTitle } from '@/environments'

const ArchiveProgramCategory = () => import('./Main')

const route = {
  path: '/archive/program/:year/:categoryName',
  name: 'programArchiveCategory',
  meta: {
    title: `Archive - ${getBaseMetaTitle}`
  },
  component: ArchiveProgramCategory
}

export default route
